import React from 'react';
import { MessageModel } from '../models/MessageModel';
import { MessageAttachmentModel } from '../models/MessageAttachmentModel';
import { formatDate } from '../utils/dateUtils';

interface MessageBubbleCompProps {
    msg: MessageModel;
    threadId: number;
    onOpenAttachment: (
        threadId: number,
        messageId: number,
        attachment: MessageAttachmentModel
    ) => Promise<void>;
}

const MessageBubbleComp: React.FC<MessageBubbleCompProps> = ({
    msg,
    threadId,
    onOpenAttachment
}) => {
    return (
        <>
            <div
                className={`chat-bubble rounded-3 ps-3 pt-2 pb-2 pe-3 position-relative ${
                    msg.senderRole === 'Buyer'
                        ? 'align-self-start bg-white'
                        : 'align-self-end right'
                }`}
                style={{ maxWidth: '300px' }}
            >
                <div style={{ whiteSpace: 'pre-line' }}>
                    {msg.messageContent}
                </div>

                {msg.attachments?.length > 0 && (
                    <>
                        <hr className="my-2" />
                        <div className="small fw-semibold mb-2">Attachments</div>

                        <div className="d-flex flex-column gap-1">
                            {msg.attachments.map((att) => (
                                <a
                                    key={att.messageAttachmentId}
                                    href="#"
                                    className="btn btn-link p-0 text-start text-decoration-underline text-white"
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        await onOpenAttachment(threadId, msg.messageId, att);
                                    }}
                                    style={{
                                        maxWidth: '100%',
                                        wordBreak: 'break-all'
                                    }}
                                >
                                    {att.fileName}
                                </a>
                            ))}
                        </div>
                    </>
                )}

                <div
                    className={`chat-tip ${
                        msg.senderRole === 'Buyer' ? 'left' : 'right'
                    }`}
                />
            </div>

            <div
                className={`${
                    msg.senderRole === 'Buyer'
                        ? 'text-start'
                        : 'text-end'
                } ps-1 pt-1 text-muted small mb-3`}
            >
                {formatDate(msg.createdTime)}
            </div>
        </>
    );
};

export default MessageBubbleComp;